import React, { useCallback, useState } from 'react';
import { Plus } from 'lucide-react';

import { useXomicsAuth } from './AuthContext';
import { loadCommerceSettings } from './api';
import {
  Failed, Head, Loading, SearchField,
} from './parts';
import { Categories } from './ProductCommerceSettings';
import { FilterMenu } from './ProductFilter';
import { useLiveResource } from './useLive';
import { tx } from './i18n';
import './products.css';

// The catalogue's categories: the groups its products sit in, a top one and
// the ones under it. The only place a category is added.
export default function XomicsCategories() {
  const { permissions } = useXomicsAuth();
  const mayManage = permissions.includes('PRODUCT_MANAGE');
  const settings = useLiveResource(['products'], useCallback(() => loadCommerceSettings(), []));
  const [query, setQuery] = useState('');
  // Every category, the active ones, or the inactive ones.
  const [status, setStatus] = useState('all');
  const [creating, setCreating] = useState(false);

  if (settings.error) return <Failed message={settings.error} onRetry={settings.refresh} />;
  if (settings.data === null) return <Loading label={tx("ui.products.reading_the_catalogue_2a05727e")} />;

  const { categories } = settings.data;
  const active = categories.filter((category) => category.isActive).length;

  return (
    <div className="xo-products-page xo-pc-page">
      <Head title={tx('ui.nav.categories')} subtitle={tx('ui.store.subtitle.categories')}>
        {mayManage && (
          <button type="button" className="xo-btn" onClick={() => setCreating(true)}>
            <Plus aria-hidden="true" />{tx('ui.products.settings.add_category')}</button>
        )}
      </Head>
      <div className="xo-product-navigation">
        <div className="xo-product-toolbar">
          <SearchField className="xo-product-search" value={query} onChange={setQuery} placeholder={tx('ui.store.search_categories')} />
          <div className="xo-product-toolbar-actions">
            <FilterMenu value={status} onChange={setStatus} label={tx('ui.store.filter')} options={[
              { value: 'all', label: tx('ui.store.all_categories'), count: categories.length },
              { value: 'active', label: tx('ui.values.active'), count: active },
              { value: 'inactive', label: tx('ui.values.inactive'), count: categories.length - active },
            ]} />
          </div>
        </div>
      </div>
      <Categories categories={categories} query={query} status={status} mayManage={mayManage}
        creating={creating} onCreating={setCreating} onChanged={settings.refresh} />
    </div>
  );
}
